import { Component, OnInit, AfterViewInit } from '@angular/core';
declare var AOS: any;
@Component({ selector: 'app-sol-device-store', templateUrl: './device-store.component.html', styleUrls: ['./device-store.component.scss'], standalone: false })
export class DeviceStoreComponent implements OnInit, AfterViewInit {
  activeSection = 'overview';
  sections = [
    { id: 'overview', label: 'Overview', icon: 'bx-layer' },
    { id: 'products', label: 'Products', icon: 'bx-devices' },
    // { id: 'howto', label: 'How to Buy', icon: 'bx-cart' },
  ];
  products = [
    { icon: 'bx-plug', name: 'OBD Dongle', desc: 'Plug-and-play vehicle connectivity — instant telematics without any installation.' },
    { icon: 'bx-chip', name: 'TCU Device', desc: 'Hardwired telematics control unit for always-on, tamper-proof vehicle connectivity.' },
    { icon: 'bx-camera', name: 'Camzo Dashcam', desc: 'Smart dashcam with dual-camera recording, Wi-Fi app access, playback, and contextual alerts.' },
    { icon: 'bx-desktop', name: 'Digital Cluster', desc: 'Retrofit digital instrument cluster with ConnectIQ integration for older vehicles.' },
  ];
  ngOnInit() {}
  ngAfterViewInit() { try { AOS.refresh(); } catch (e) {} }
  scrollTo(id: string) {
    this.activeSection = id;
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
